import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { FulfillService } from '../../fulfill.service';
import { Shop } from '@app/services/shops/shop.model';
import { OrderUpdateCase } from '@pages/workspace/fulfill/utils/models';
import { takeUntil } from 'rxjs/operators';
import { isBundleOrder } from '@utils/order.utils';

@Component({
  selector: 'fulfill-side-panel-order-footer',
  templateUrl: './fulfill-side-panel-order-footer.component.html',
  styleUrls: ['./fulfill-side-panel-order-footer.component.scss'],
  standalone: false,
})
export class FulfillSidePanelOrderFooterComponent implements OnInit, OnDestroy {
  @Input() shop: Shop;
  private destroy$ = new Subject();
  isSaveDisabled: boolean = false;
  isPickingMode: boolean = false;
  loading = false;

  constructor(private fulfillService: FulfillService) {}

  ngOnInit(): void {
    this.fulfillService.onLoading.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      if (!state) this.loading = false;
    });
    const activeOrder = this.fulfillService.activeOrder;
    if (
      activeOrder.updateType?.includes(OrderUpdateCase.LINE_ITEMS_CHANGED) ||
      activeOrder.updateTypeV2?.includes(OrderUpdateCase.LINE_ITEMS_LOCATION_CHANGED)
    ) {
      this.isSaveDisabled = true;
    }
    this.isPickingMode = this.fulfillService.isPickingMode;

    this.fulfillService.onResetUpdateType$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.isSaveDisabled = false;
    });
  }
  isBundle() {
    return isBundleOrder(this.fulfillService.activeOrder);
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  saveAsPartiallyFulfilled() {
    if (!this.fulfillService.checkAbilityToFulfill()) return;
    this.loading = true;
    this.fulfillService.fulfillItems();
    this.loading = false;
  }

  saveAsPartiallyPicked() {
    if (!this.fulfillService.checkAbilityToFulfill()) return;
    this.loading = true;
    this.fulfillService.pickItems();
    this.loading = false;
  }
}
